module.exports = __webpack_public_path__ + "static/media/dmkd.1be13e7e.jpeg";